import React, { useState, Fragment, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { Textarea, Radio, Group, Button, CloseButton, TextInput, Notification } from '@mantine/core';
import { getData, postData } from '../services/fetch-service';
import { useSelector } from 'react-redux';
import UploadFile from '../shared/UploadFile';
import { GrDocumentText } from 'react-icons/gr';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { RxCross1 } from "react-icons/rx";

const CommentForm = ({ onCommentPosted }) => {
    const ReferenceId = useSelector((state) => state.WebsiteLanguage.data.ReferenceId);
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);
    const ValidationTranslations = useSelector((state) => state.WebsiteLanguage.data.ValidationTranslations);

    const validationSchema = Yup.object().shape({
        komenti: Yup.string().required(`${ValidationTranslations.requiredField}`),
        dokumentet: Yup.string()
            .required(`${ValidationTranslations.requiredField}`)
            .test(
                `${ValidationTranslations.documentsRequired}`,
                `${ValidationTranslations.addDocuments}`,
                function (value) {
                    if (this.parent.dokumentet === '1' && savedDocuments.length === 0) {
                        return false;
                    }
                    return true;
                }
            ),
    });

    const formik = useFormik({
        initialValues: {
            komenti: '',
            raportimiStatusiId: 15,
            dokumentet: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            postComment(values);
            resetForm();
        },
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [documentName, setDocumentName] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [savedDocuments, setSavedDocuments] = useState([]);
    const [NotificationBox, setNotificationBox] = useState(null);

    const [languageValue, setLanguageValue] = useState(1);

    useEffect(() => {
        const languageMap = {
            'sq': 1,
            'en': 2,
            'sr': 3
        };

        setLanguageValue(languageMap[WebsiteLanguage]);
    }, [WebsiteLanguage]);

    const handleFileChange = async (file) => {
        try {
            const lastDotIndex = file.name.lastIndexOf('.');
            const fileType = file.name.slice(lastDotIndex);

            const checkMedia = await getData(`Deklarimi/CheckMedia?size=${file.size}&format=${fileType}&webLang=${languageValue}`);

            if (checkMedia && checkMedia.status === 200) {
                setSelectedFile(file);
            } else {
                throw new Error('Error invalid file');
            }
        } catch (error) {
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.CheckMediaErrorAlert}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
            setSelectedFile(null);
        }
    };

   const handleSave = async () => {
        try {
            if (selectedFile && documentName) {
                const updatedFile = new Blob([selectedFile], { type: selectedFile.type });
                updatedFile.name = documentName + documentType;

                const newDocument = {
                    file: updatedFile,
                };

                setSavedDocuments((prevDocuments) => [...prevDocuments, newDocument]);
                setSelectedFile(null);
                setDocumentName('');
                setDocumentType('');
            }
        } catch (error) {
            setSelectedFile(null);
            setDocumentName('');
            setDocumentType('');

            if (error.response && error.response.data) {
                setNotificationBox(
                    <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                        {error.response.data[0].message}
                    </Notification>
                );
                setTimeout(() => {
                    setNotificationBox(null);
                }, 5000);
            }
        }
    };


    const handleDelete = (index) => {
        const updatedDocuments = [...savedDocuments];
        updatedDocuments.splice(index, 1);
        setSavedDocuments(updatedDocuments);
    };

    const handleCloseButtonClick = () => {
        setNotificationBox(null);
    }

    const [RaportimiHistoriaId, setRaportimiHistoriaId] = useState();

    const postComment = async (data) => {
        try {
            const newData = {
                ...data,
                raportimiId: ReferenceId,
            }
            const response = await postData('Raportet/CreateRaportimetHistoria', newData);
            if (response) {
                if (response.data && response.status === 201) {
                    setRaportimiHistoriaId(response.data.id);
                    if (formik.values.dokumentet === '2') {
                        setIsLoading(false);
                        onCommentPosted();
                    }
                }
            }
        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    const postDocuments = async () => {
        try {
            const data = {
                RaportimiId: ReferenceId,
                RaportimiHistoriaId: RaportimiHistoriaId,
                DokumentShtese: true,
                Files: savedDocuments,
                Publik: true,
            };

            let formData = new FormData();

            data.Files.forEach((doc) => {
                formData.append('Files', doc.file, doc.file.name);
            });

            formData.append('RaportimiId', data.RaportimiId);
            formData.append('RaportimiHistoriaId', data.RaportimiHistoriaId);
            formData.append('DokumentShtese', data.DokumentShtese);
            formData.append('Publik', data.Publik);

            const response = await postData('Deklarimi/InsertRaportimetMedia', formData);

            if (response) {
                setSavedDocuments([]);
                setIsLoading(false);
                onCommentPosted();
                if (response.status === 200) {
                    if (formik.values.dokumentet === '1') {

                    }
                }
            }
        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                      {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    useEffect(() => {
        if (RaportimiHistoriaId && savedDocuments && savedDocuments.length > 0) {
            postDocuments();
        }
    }, [RaportimiHistoriaId, savedDocuments]);

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setIsLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    };

    useEffect(() => {
        if (selectedFile) {
            const lastDotIndex = selectedFile.name.lastIndexOf('.');
            const nameWithoutExtension = selectedFile.name.slice(0, lastDotIndex);
            const fileType = selectedFile.name.slice(lastDotIndex);
            setDocumentName(nameWithoutExtension);
            setDocumentType(fileType);
        }
    }, [selectedFile])


    const clearInputValue = () => {
        setDocumentName('');
        setDocumentType('');
        setSelectedFile(null);
    };

    return (
        <Fragment>
            <div className="form-comment">
                <Textarea
                    rows={6}
                    placeholder={ControlsTranslations.WriteComment}
                    required
                    name='komenti'
                    onChange={formik.handleChange}
                    value={formik.values.komenti}
                    onBlur={formik.handleBlur}
                    error={formik.touched.komenti && formik.errors.komenti}
                    inputWrapperOrder={['label', 'error', 'input']}
                    className="resizable-textarea"
                />
                <Radio.Group
                    label={ControlsTranslations.documentsAttachedLabel}
                    name='dokumentet'
                    withAsterisk
                    value={formik.values.dokumentet}
                    onChange={(value) => formik.setFieldValue('dokumentet', value)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.dokumentet && formik.errors.dokumentet}
                    inputWrapperOrder={['label', 'error', 'input']}
                >
                    <Group mt="xs">
                        <Radio color="#051A53" value="1" label={`${ControlsTranslations.yes}`} />
                        <Radio color="#051A53" value="2" label={`${ControlsTranslations.no}`} />
                    </Group>
                </Radio.Group>
                {formik.values.dokumentet === '1' &&
                    <Fragment>
                        <Group mt="xs" mb={savedDocuments && savedDocuments.length === 0 && 'xs'}>
                            <UploadFile onFileChange={handleFileChange} />
                            <Group>
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={selectedFile ? <GrDocumentText /> : null}
                                    placeholder={GeneralTranslations.documentName}
                                    // error={}
                                    rightSection={
                                        selectedFile ? (
                                            <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                        ) : null
                                    }
                                    className="doc-input"
                                    value={documentName}
                                    onChange={(e) => setDocumentName(e.target.value)}
                                />
                                {selectedFile &&
                                    <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                }
                            </Group>
                        </Group>
                        {savedDocuments.length > 0 && (
                            <div className='document-list'>
                                <ul>
                                    {savedDocuments.map((doc, index) => (
                                        <li key={index}>
                                            <Group>
                                                <div className="doc-contnet">
                                                    <Group>
                                                        <IoDocumentTextOutline size={22} />
                                                        <span>
                                                            {doc.file.name}
                                                        </span>

                                                    </Group>
                                                </div>

                                                <div className="doc-actions">
                                                    <CloseButton onClick={() => handleDelete(index)} variant="transparent" />
                                                </div>
                                            </Group>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </Fragment>
                }

                <Button
                    type="submit"
                    // leftSection={active === 2 && <FaCheck />}
                    className="form-btn btn-base-small btn-search-report"
                    onClick={() => {
                        handleSubmit();
                    }}
                // disabled={isLoading}
                >
                    {isLoading ? `${ControlsTranslations.SendLoading}` : `${ControlsTranslations.Send}`}
                </Button>
            </div>
            <div className="notification-cm">
                {NotificationBox}
            </div>
        </Fragment>
    )
}

export default CommentForm